/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Target language locale — AI will match input language if not specified
 */
export enum ImproveActivityDescriptionBodyLocale {
  en = 'en',
  fr = 'fr',
  es = 'es'
}
